import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const highlightedArticles = articles.filter((a) =>
  ['guide-intro', 'lucky-wheel-strategy', 'download-guide'].includes(a.slug)
);

export default function ArticleHighlightsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              游戏攻略与资讯
            </h2>
            <p className="text-sm text-foreground-500">最新游戏攻略、下载教程和使用指南</p>
          </div>
          <Link
            to="/article/guide-intro"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            更多文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {highlightedArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group p-5 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors duration-200 cursor-pointer"
            >
              <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700 mb-3">
                {article.category}
              </span>
              <h3 className="font-heading text-sm text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i> {article.date}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i> {article.readTime}
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/article/guide-intro"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            更多文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}